import { useEffect } from "react";
import FullScreenPanel from "app/ui/FullScreenPanel";
import cn from "app/utils/classnames";

const CREDITS = [
  { role: "Original game concept", name: "Answer in Progress" },
  {
    role: "Game design",
    name: "Answer in Progress, Paolo Pasco, Alex Rosenthal",
  },
  { role: "Director", name: "Alex Rosenthal" },
  { role: "Front end Design and Development", name: "Dennis Carr" },
  { role: "Back end Development", name: "Nick Coyne, Kara Todd" },
  { role: "Visual Design", name: "Answer in Progress, Natalia Ammon" },
  { role: "Editor", name: "Paolo Pasco" },
  { role: "Quality Assurance", name: "Abi Dandrea" },
];

interface CreditsProps {
  onClose: () => void;
}

export default function Credits(props: CreditsProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <FullScreenPanel
      className="bg-background"
      heading="Credits"
      headingClassName="px-9 py-3"
      onClose={props.onClose}
    >
      <ul className="flex flex-col gap-5">
        {CREDITS.map((credit) => (
          <CreditEntry role={credit.role} name={credit.name} />
        ))}
      </ul>
    </FullScreenPanel>
  );
}

interface CreditEntryProps {
  role: string;
  name: string;
}

function CreditEntry({ role, name }: CreditEntryProps) {
  return (
    <li className={cn("flex flex-col items-center")}>
      <p className="text-sm">{role}</p>
      <p className="text-center font-bold">{name}</p>
    </li>
  );
}
